import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, SearchIcon, FilterIcon, DownloadIcon, MoreHorizontalIcon, ChevronDownIcon, UserIcon } from 'lucide-react';
export function DealsTable() {
  const [searchTerm, setSearchTerm] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  // Mock data for deals
  const mockDeals = [{
    id: '1001',
    title: 'Purchase - Sarah Strauss & Michael Bray',
    client: 'Sarah Strauss & Michael Bray',
    value: '$425,000',
    stage: 'Lead',
    lender: '',
    closingDate: '2023-10-15'
  }, {
    id: '1002',
    title: 'Refinance - Emily Johnson',
    client: 'Emily Johnson',
    value: '$350,000',
    stage: 'Pre-Approval',
    lender: '',
    closingDate: '2023-11-01'
  }, {
    id: '1003',
    title: 'Purchase - David Chen',
    client: 'David Chen',
    value: '$380,000',
    stage: 'Pre-Approval',
    lender: '',
    closingDate: '2023-10-30'
  }, {
    id: '1004',
    title: 'Purchase - Robert & Lisa Taylor',
    client: 'Robert & Lisa Taylor',
    value: '$425,000',
    stage: 'Live Deal',
    lender: 'First National',
    closingDate: '2023-09-25'
  }, {
    id: '1005',
    title: 'Purchase - Jennifer Smith',
    client: 'Jennifer Smith',
    value: '$510,000',
    stage: 'Approved',
    lender: 'TD Bank',
    closingDate: '2023-09-15'
  }];
  // Filter deals based on search term
  const filteredDeals = mockDeals.filter(deal => deal.title.toLowerCase().includes(searchTerm.toLowerCase()) || deal.client.toLowerCase().includes(searchTerm.toLowerCase()) || deal.lender.toLowerCase().includes(searchTerm.toLowerCase()));
  const getStageBadgeClass = (stage: string) => {
    switch (stage) {
      case 'Lead':
        return 'badge badge-primary';
      case 'Pre-Approval':
        return 'badge badge-warning';
      case 'Live Deal':
        return 'badge badge-success';
      case 'Approved':
        return 'badge badge-success';
      case 'Conditions Met':
        return 'badge badge-success';
      case 'Closing':
        return 'badge badge-danger';
      case 'Closed':
        return 'badge badge-neutral';
      default:
        return 'badge badge-neutral';
    }
  };
  return <div data-id="element-1668">
      <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center mb-6" data-id="element-1669">
        <h1 className="text-2xl font-bold text-neutral-900" data-id="element-1670">Deals</h1>
        <div className="flex space-x-2" data-id="element-1671">
          <Link to="/deals/kanban" className="btn btn-outline" data-id="element-1672">
            Kanban View
          </Link>
          <button className="btn btn-primary" data-id="element-1673">
            <PlusIcon className="mr-2 h-4 w-4" data-id="element-1674" />
            New Deal
          </button>
        </div>
      </div>
      <div className="card" data-id="element-1675">
        {/* Table Toolbar */}
        <div className="mb-4 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-1676">
          <div className="relative w-full sm:max-w-xs" data-id="element-1677">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-1678">
              <SearchIcon className="h-5 w-5 text-neutral-400" data-id="element-1679" />
            </div>
            <input type="text" className="input w-full pl-10" placeholder="Search deals..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1680" />
          </div>
          <div className="flex items-center space-x-2" data-id="element-1681">
            <button className="btn btn-outline relative" onClick={() => setIsFilterOpen(!isFilterOpen)} data-id="element-1682">
              <FilterIcon className="mr-2 h-4 w-4" data-id="element-1683" />
              Filters
            </button>
            <button className="btn btn-outline" data-id="element-1684">
              <DownloadIcon className="mr-2 h-4 w-4" data-id="element-1685" />
              Export
            </button>
          </div>
        </div>
        {/* Filters Panel */}
        {isFilterOpen && <div className="mb-4 rounded-md border border-neutral-200 bg-neutral-50 p-4" data-id="element-1686">
            <div className="flex items-center justify-between" data-id="element-1687">
              <h3 className="text-sm font-medium text-neutral-900" data-id="element-1688">Filters</h3>
              <button className="text-sm text-primary-600 hover:text-primary-500" data-id="element-1689">
                Clear all
              </button>
            </div>
            <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-4" data-id="element-1690">
              {/* Stage Filter */}
              <div data-id="element-1691">
                <h4 className="mb-2 text-xs font-medium text-neutral-500" data-id="element-1692">
                  Stage
                </h4>
                <div className="space-y-2" data-id="element-1693">
                  {['Lead', 'Pre-Approval', 'Live Deal', 'Approved', 'Conditions Met', 'Closing', 'Closed'].map(stage => <label key={stage} className="flex items-center" data-id="element-1694">
                      <input type="checkbox" className="h-4 w-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500" data-id="element-1695" />
                      <span className="ml-2 text-sm text-neutral-700" data-id="element-1696">
                        {stage}
                      </span>
                    </label>)}
                </div>
              </div>
              {/* Lender Filter */}
              <div data-id="element-1697">
                <h4 className="mb-2 text-xs font-medium text-neutral-500" data-id="element-1698">
                  Lender
                </h4>
                <div className="space-y-2" data-id="element-1699">
                  {['TD Bank', 'RBC', 'Scotiabank', 'First National', 'MCAP'].map(lender => <label key={lender} className="flex items-center" data-id="element-1700">
                      <input type="checkbox" className="h-4 w-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500" data-id="element-1701" />
                      <span className="ml-2 text-sm text-neutral-700" data-id="element-1702">
                        {lender}
                      </span>
                    </label>)}
                </div>
              </div>
              {/* Closing Date Filter */}
              <div data-id="element-1703">
                <h4 className="mb-2 text-xs font-medium text-neutral-500" data-id="element-1704">
                  Closing Date
                </h4>
                <div className="space-y-2" data-id="element-1705">
                  {[{
                value: 'all',
                label: 'All Time'
              }, {
                value: 'this-month',
                label: 'This Month'
              }, {
                value: 'next-month',
                label: 'Next Month'
              }, {
                value: 'next-90-days',
                label: 'Next 90 Days'
              }].map(option => <label key={option.value} className="flex items-center" data-id="element-1706">
                      <input type="radio" name="closing-date" className="h-4 w-4 border-neutral-300 text-primary-600 focus:ring-primary-500" data-id="element-1707" />
                      <span className="ml-2 text-sm text-neutral-700" data-id="element-1708">
                        {option.label}
                      </span>
                    </label>)}
                </div>
              </div>
              {/* Value Filter */}
              <div data-id="element-1709">
                <h4 className="mb-2 text-xs font-medium text-neutral-500" data-id="element-1710">
                  Value
                </h4>
                <div className="space-y-4" data-id="element-1711">
                  <div data-id="element-1712">
                    <label className="block text-sm text-neutral-700" data-id="element-1713">
                      Min Value
                    </label>
                    <input type="text" className="input w-full mt-1" placeholder="$" data-id="element-1714" />
                  </div>
                  <div data-id="element-1715">
                    <label className="block text-sm text-neutral-700" data-id="element-1716">
                      Max Value
                    </label>
                    <input type="text" className="input w-full mt-1" placeholder="$" data-id="element-1717" />
                  </div>
                </div>
              </div>
            </div>
          </div>}
        {/* Deals Table */}
        <div className="overflow-x-auto" data-id="element-1718">
          <table className="min-w-full divide-y divide-neutral-200" data-id="element-1719">
            <thead className="bg-neutral-50" data-id="element-1720">
              <tr data-id="element-1721">
                <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-1722">
                  <div className="flex items-center" data-id="element-1723">
                    Deal Name
                    <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-1724" />
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-1725">
                  <div className="flex items-center" data-id="element-1726">
                    Client
                    <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-1727" />
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-1728">
                  <div className="flex items-center" data-id="element-1729">
                    Value
                    <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-1730" />
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-1731">
                  Stage
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-1732">
                  Lender
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-1733">
                  <div className="flex items-center" data-id="element-1734">
                    Closing Date
                    <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-1735" />
                  </div>
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-1736">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-neutral-200" data-id="element-1737">
              {filteredDeals.map(deal => <tr key={deal.id} className="hover:bg-neutral-50" data-id="element-1738">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1739">
                    <Link to={`/deals/${deal.id}`} className="text-sm font-medium text-primary-600 hover:text-primary-500" data-id="element-1740">
                      {deal.title}
                    </Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1741">
                    <div className="flex items-center" data-id="element-1742">
                      <div className="h-8 w-8 rounded-full bg-neutral-200 flex items-center justify-center" data-id="element-1743">
                        <UserIcon className="h-4 w-4 text-neutral-600" data-id="element-1744" />
                      </div>
                      <span className="ml-2 text-sm text-neutral-900" data-id="element-1745">
                        {deal.client}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500" data-id="element-1746">
                    {deal.value}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1747">
                    <span className={getStageBadgeClass(deal.stage)} data-id="element-1748">
                      {deal.stage}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500" data-id="element-1749">
                    {deal.lender || '—'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500" data-id="element-1750">
                    {new Date(deal.closingDate).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1751">
                    <button className="text-primary-600 hover:text-primary-900" data-id="element-1752">
                      <MoreHorizontalIcon className="h-5 w-5" data-id="element-1753" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {filteredDeals.length === 0 && <div className="py-12 text-center" data-id="element-1754">
              <p className="text-neutral-500" data-id="element-1755">
                No deals found matching your criteria.
              </p>
            </div>}
        </div>
        {/* Pagination */}
        <div className="flex items-center justify-between border-t border-neutral-200 bg-white px-4 py-3 sm:px-6" data-id="element-1756">
          <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" data-id="element-1757">
            <div data-id="element-1758">
              <p className="text-sm text-neutral-700" data-id="element-1759">
                Showing <span className="font-medium" data-id="element-1760">1</span> to{' '}
                <span className="font-medium" data-id="element-1761">{filteredDeals.length}</span> of{' '}
                <span className="font-medium" data-id="element-1762">{filteredDeals.length}</span>{' '}
                results
              </p>
            </div>
            <div data-id="element-1763">
              <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination" data-id="element-1764">
                <a href="#" className="relative inline-flex items-center rounded-l-md px-2 py-2 text-neutral-400 ring-1 ring-inset ring-neutral-300 hover:bg-neutral-50" data-id="element-1765">
                  <span className="sr-only" data-id="element-1766">Previous</span>
                  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-1767">
                    <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd" data-id="element-1768" />
                  </svg>
                </a>
                <a href="#" aria-current="page" className="relative z-10 inline-flex items-center bg-primary-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600" data-id="element-1769">
                  1
                </a>
                <a href="#" className="relative inline-flex items-center rounded-r-md px-2 py-2 text-neutral-400 ring-1 ring-inset ring-neutral-300 hover:bg-neutral-50" data-id="element-1770">
                  <span className="sr-only" data-id="element-1771">Next</span>
                  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-1772">
                    <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" data-id="element-1773" />
                  </svg>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>;
}